import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Title, Paragraph } from '../general/stylesComponents/stylesComponents';
import { useAuthContext } from '../../../contexts/authContext';
import { PageNotFoundMessage } from '../../../shared/messages/pageNotFoundMessage';

const PageNotFound = () => {
    const { modeTheme } = useAuthContext();
    const { TITLE, SUBTITLE, MESSAGE } =
        PageNotFoundMessage.pageNotFoundMessages;

    return (
        <Box id="Page Not Found">
            <Container maxWidth="md" style={{ marginTop: 20 }}>
                <Box mt={8}>
                    <Title variant="h4" modeTheme={modeTheme}>
                        {TITLE}
                    </Title>
                    <Typography
                        align="center"
                        sx={{
                            fontSize: { xs: 200, lg: 250 },
                            fontWeight: 'bold',
                            fontFamily: 'fantasy',
                            color: 'primary.main',
                        }}
                    >
                        404
                    </Typography>
                    <Paragraph modeTheme={modeTheme}>{SUBTITLE}</Paragraph>
                    <Typography
                        align="center"
                        variant="subtitle2"
                        sx={{ color: 'primary.main' }}
                    >
                        {MESSAGE}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default PageNotFound;
